<template>
    <Menu as="div" class="relative z-20">
        <div>
            <MenuButton
                class="flex items-center rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-50 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
            >
                <Bars3Icon class="h-4 w-4" />
            </MenuButton>
        </div>
        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems
                class="absolute right-0 mt-2 w-52 origin-top-right divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white shadow-lg focus:outline-none dark:divide-gray-700 dark:border-gray-600 dark:bg-gray-800"
            >
                <div class="p-1">
                    <MenuItem v-slot="{ active, close }">
                        <a
                            @click.prevent="close(); $emit('refund');"
                            class="flex items-center rounded-md px-3 py-2 text-sm transition-colors hover:cursor-pointer"
                            :class="active ? 'bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white' : 'text-gray-700 dark:text-gray-300'"
                        >
                            Reembolsar Transações
                        </a>
                    </MenuItem>
                    <MenuItem v-slot="{ active, close }">
                        <a
                            @click.prevent="close(); $emit('exportPdf');"
                            class="flex items-center rounded-md px-3 py-2 text-sm transition-colors hover:cursor-pointer"
                            :class="active ? 'bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white' : 'text-gray-700 dark:text-gray-300'"
                        >
                            Exportar PDF
                        </a>
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script>
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
} from "@headlessui/vue";
import { Bars3Icon } from "@heroicons/vue/20/solid";

export default {
    props: ["audit"],
    components: {
        Bars3Icon,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
    },

    emits: ["refund", "exportPdf", "fetch"],

    methods: {},
};
</script>
